import LayoutPrimary from '../../layouts/Primary';
import CardCreate from '../../views/Admin/Config/Card/CardCreate';
import CardIndex from '../../views/Admin/Config/Card/CardIndex';
import CardEdit from '../../views/Admin/Config/Card/CardEdit';

export default [
    {
        path: '/card/create',
        name: 'CardCreate',
        component: CardCreate,
        meta: {
            requiresAuth: true,
            layout: LayoutPrimary,
        },
    },
    {
        path: '/card/index',
        name: 'CardIndex',
        component: CardIndex,
        meta: {
            requiresAuth: true,
            layout: LayoutPrimary,
        },
        props: true,
    },
    {
        path: '/card/edit/:id',
        name: 'CardEdit',
        component: CardEdit,
        meta: {
            requiresAuth: true,
            layout: LayoutPrimary,
        },
    },
];
